<template>
	<div id="APPROOT" :class="{[gtCssClass]: gtCssClass, [variantCssClass]: variantCssClass}">
		<v-btn v-if="isNextVersion" class="version" small @click.stop="removeVersion">Next Version</v-btn>
		<div :class="[isAdminRoute ? 'admin' : '' || isFrontRoute ? 'shop-app' : ''] + ' ' + screenId + ' ' + routeAppClass + ' ' + [channelAliasKiosk ? 'is-kiosk-app channel-kiosk' : ''] + ' ' + [channelAliasDesktop ? 'channel-desktop': ''] + [platform ? 'mobile-app': ''] " class="background-sunset ios-hybrid-app">
			<v-app>
				<div class="full-height-fix">
					<template v-if="isBrowserSupportDiscontinued">
						<div class="top-space-smag"></div>
						<div class="bilka-top-text">tilgængeligt</div>
						<div class="bilka-logo-disable-page"><img src="../static/tid2/images/apple-icon-167x167.jpg"/></div>
						<div class="smag-image-background"><img src="../static/tid5/images/SALLING_TOPBANNER2.jpg" /></div>
						<div class="smag-logo-disable-page"><img src="../static/tid5/images/smag-logo.png"/></div>
						<div class="fotex-image-background"><img src="../static/tid5/images/smag-logo.png" /></div>
						<div class="fotex-logo-disable-page"><img src="../static/tid3/images/logo_fotex_mad_ud_af_huset.svg"/></div>
						<div class="sunset-logo-disable-page"><img src="../static/tid100/images/modalTopLogo.png"/></div>
						<div class="bilka fotex smag sunset">
							<div class="bil-brocken sm-brocken fo-brocken all-tenants-ie">
								Internet Explorer understøttes ikke fra 1. maj
							</div>
							<div class="sunset-brocken ">
								Internet Explorer understøttes ikke.
							</div>
							<div class="bil-brocken-sub-bold sm-brocken-sub-bold fo-brocken-sub-bold sunset-brocken-sub-bold">
								Fra 1. maj 2019 vil det af tekniske og sikkerhedsmæssige årsager ikke være muligt at benytte Internet Explorer.
							</div>
							<div class="bilka-ie smag-ie fotex-ie">
								{{tenantName}} Mad ud af Huset vil ikke længere kunne tilgås med Internet Explorer,
								da browseren er forældet og ikke kan understøtte nye opdateringer.
								Benyt venligst en anden browser, f.eks. Chrome, Safari, Firefox eller Edge.
							</div>
							<div class="sunset-ie">
								{{tenantName}} vil ikke længere kunne tilgås med Internet Explorer,
								da browseren er forældet og ikke kan understøtte nye opdateringer.
								Benyt venligst en anden browser, f.eks. Chrome, Safari, Firefox eller Edge.
							</div>
							<div class="available-browsers">Understøttede browsere:</div>
							<img src="../static/tid2/images/browsers-v1.png" class="image-browsers"/>
						</div>
						<div class="fotex-bottom smag-bottom">tilgængeligt</div>
					</template>
					<template v-else>
						<template v-if="isAdminRoute">
							<top-menu-admin ref="topMenuAdmin"></top-menu-admin>
							<nav-bar-admin v-if="betaMode" :open="isNavBarOpen" :margin-top="topMenuAdminHeight"/>
							<admin-app-wrapper v-if="isAdminRoute">
								<router-view @get-new-messages="handleNewMessageApiCall"></router-view>
							</admin-app-wrapper>
						</template>
						<template v-else>
							<template v-if="showNotAvailable || showNotAvailableAndroid || showNotAvailableIos || showNotAvailableDesktopBrowser || showNotAvailableKiosk || showNotAvailableMobileBrowser">
								<template >
									<component
											:is="templateType"
											:siteNotAvailableRedirect="siteNotAvailableRedirect"
											:platform="platform"
									/>
								</template>
							</template>
							<template v-else-if="isFrontRoute">
								<shop-root />
							</template>
						</template>
					</template>
				</div>

				<modal-component
						v-if="globalInfoDialog"
						:classes="!isAdminRoute ? errorClasses : ''"
						:class="{'favouriteError' : this.$store.getters.featureToggles.favoriteProducts}"
						:onClose="closeInfoDialog"
						:showLoginButton="$route.name === 'deliveryMethod' && $store.getters.getLoginHistory && !$store.getters.applicationUserLoggedIn"
						@redirectToLogin="redirectToLoginRoute()"
				>
						{{ $t(globalInfoDialog) }}
				</modal-component>
				<div v-if="isPopupEnv">
					<modal-component
						v-if="globalErrorMessage && !globalError.suppressUserWarning"
						:onClose="closeErrorMessage" :classes="errorClasses">
						<template v-if="channelAliasKiosk">
							<div style="padding: 1.5em">
								{{ customGlobalErrorMessage !== null ? customGlobalErrorMessage : globalErrorMessage }}
							</div>
						</template>
						<template v-else>
							{{ customGlobalErrorMessage !== null ? customGlobalErrorMessage : globalErrorMessage }}
						</template>
					</modal-component>
				</div>
				<div v-else>
					<div v-if="globalErrorMessage && !globalError.suppressUserWarning" @click="closeErrorMessage()" class="global-error"
						 :class="{'has-error': globalErrorMessage}">
						<div class="close">LUK</div>
						{{ customGlobalErrorMessage !== null ? customGlobalErrorMessage : globalErrorMessage }}
					</div>
				</div>
				<expired-gift-dialog
					:modalComponentShown="selectionExpiredMessage"
					:onClose="expiredGiftDialog.onClose"
				/>
			</v-app>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	import TopMenuAdmin from "./components/Admin/TopMenuAdmin.vue";
	import NotAvailable from "./components/UtilityComponents/NotAvailable";
	import ShopRoot from "./components/GlobalSharedComponents/Shop/ShopRoot";
	import ModalComponent from "./components/UtilityComponents/ModalComponent";
	import ExpiredGiftDialog from "./components/ShopComponents/gt2/ShoppingCart/_steps/ExpiredGiftDialog-gt2";
	import SiteNotAvailableTid1 from "./components/ShopComponents/gtDemo/Tenants/SiteNotAvailableTid1-gtDemo";
	import SiteNotAvailableTid2 from "./components/ShopComponents/defaultGlobalTemplate/Tenants/SiteNotAvailableTid2";
	import SiteNotAvailableTid3 from "./components/ShopComponents/defaultGlobalTemplate/Tenants/SiteNotAvailableTid3";
	import SiteNotAvailableTid5 from "./components/ShopComponents/defaultGlobalTemplate/Tenants/SiteNotAvailableTid5";
	import SiteNotAvailableTid6 from "./components/ShopComponents/gt2/Tenants/SiteNotAvailableTid6-gt2";
	import SiteNotAvailableBM100 from "./components/ShopComponents/gt2/Tenants/SiteNotAvailableBM100-gt2";
	import * as mutationTypes from "./store/mutation-types";
	import mutationTypesBM100 from "./store/globalTemplateSpecificModules/storeModulesBM100/mutationTypesBM100";
	import routerMapper from "./router/routeMapper.js";
	import appConfig from "./appconfig";
	import { ApmHelper } from "./domains2/libraries/ApmHelper";
	import FrontendDetectionHelper from "./domains2/libraries/FrontendDetectionHelper";
	import CoreEnvironmentHelper from "./domains2/libraries/CoreEnvironmentHelper";
	import EventSource from "eventsource";
	import NavBarAdmin from "./components/Admin/NavBarAdmin";
	import _ from "lodash";
	import { subscribeToUniversalLinks, setPageTitle } from "./libraries/utils";
	import { SplashScreen } from "@capacitor/splash-screen";
	import { Device } from "@capacitor/device";
	import { StatusBar, Style } from "@capacitor/status-bar";
	import { getVersion } from "./helper/ProductHelper";
	import {onPushNotificationActionPerformedCallback, onPushNotificationReceivedCallback} from "./helper/PushNotificationHelper";
	import { redirectToAppStoreForFriendInvite } from "./helper/FriendInviteHelper";
	import {
		getGlobalTemplateReplaceCssName
	} from "./libraries/globalTemplateSpecific/bm100/utils";
	import { App as NativeApp } from "@capacitor/app";
	import { showMobileConsent } from "./helper/UserConsentHelper";
	import { checkCapacitorPushPermissions, requestCapacitorPushPermissions, addCapacitorPushListener, registerCapacitorPushNotifications } from "./helper/CapacitorPushNotificationsHelper";
	import HelloRetail from "./integrations/recommendations/helloRetail/HelloRetail";
	import { DateTime } from "luxon";
	import { collectSelectionsWithDiscount } from "./domains2/libraries/Utils";
	import { setSFMCContactKey, getSFMCContactKey, checkSFMCPushSystemPermission } from "./helper/SFMCPushNotificationsHelper.js";
	import {RECALCULATE_SUBSCRIPTION_SET_CART_ORDER_TAGS} from "./store/mutation-types";
	FrontendDetectionHelper.isFrontend = true;
	CoreEnvironmentHelper.environmentName = appConfig.envName;
	CoreEnvironmentHelper.bmId = appConfig.getBusinessModelId();
	CoreEnvironmentHelper.productCatalogOptimizationToggle = appConfig.transientReleaseToggles.productCatalogOptimization();
	CoreEnvironmentHelper.reducingNumbersOfProductCatalogCalls = appConfig.transientReleaseToggles.reducingNumbersOfProductCatalogCalls();
	CoreEnvironmentHelper.priceRulesJSONDataOptimization = appConfig.transientReleaseToggles.priceRulesJSONDataOptimization();
	const tenantConfig = appConfig.tenantConfig;

	export default {
		name: "app",
		components: {
			NavBarAdmin,
			TopMenuAdmin,
			AdminAppWrapper: () => import("./components/Admin/AdminAppWrapper.vue"),
			NotAvailable,
			ShopRoot,
			ModalComponent,
			SiteNotAvailableTid1,
			SiteNotAvailableTid2,
			SiteNotAvailableTid3,
			SiteNotAvailableTid5,
			SiteNotAvailableTid6,
			SiteNotAvailableBM100,
			ExpiredGiftDialog
		},
		data() {
			return {
				errorClasses: "global-error-message",
				expiredGiftDialog: {
					onClose() {
						this.$store.dispatch(mutationTypes.CLEAR_SELECTION_EXPIRED_MESSAGE);
					}
				},
				sseClient: null,
				sseClientInterval: null,
				topMenuAdminHeight: 0,
				timerIds: {},
				shownDialogs: {},
				discountExpirationPopupTimeInSeconds: null,
				voucherTimeouts: {} // Track timeout IDs for cleanup
			};
		},
		async created() {
			// When using auto-translate, the app frontend is having multiple issues.
			// Eg the prices are not getting updated on cart screen/component
			// another example delivery methods do not show when enabled
			// therefore disabling it
			if (appConfig.isBM100()) {
				document.getElementsByTagName("html")[0].setAttribute("translate", "no");
			}

			window.VUE_APP_INITIALIZED = true;
			const self = this;

			document.addEventListener("click", self.closeErrorMessage);

			// redirect to apple/play store
			redirectToAppStoreForFriendInvite(this.tenantSettings);

			if (appConfig.mobile.isMobileApp()) {
				await self.hideSplashScreen();

				if (appConfig.mobile.mobileApi().platformId === "android") {
					StatusBar.setOverlaysWebView({ overlay: false });
				}
				await StatusBar.setStyle({ style: Style.Dark });

				// Register PushNotifications
				const deviceInfo = await Device.getInfo();
				this.$store.commit(mutationTypes.SET_DEVICE_INFO, deviceInfo);
				// Silently register for push notifications if fcmToken is already stored (it is stored only in bm100 case - check registration listener) and notifications already accepted
				// This is in case app is re-installed (install the app again without deleting it first)
				if (appConfig.isBM100() && this.platform === "ios" && this.$store.getters.fcmToken) {
					const permStatus = await checkCapacitorPushPermissions();
					if (permStatus === "granted") {
						self.$store.commit(mutationTypes.SET_SHOULD_HANDLE_PUSH_REGISTRATION, true);
						await registerCapacitorPushNotifications();
					}
				}

				if (appConfig.isBM100()) {
					const setConsents = async () => {
						const shouldTriggerMobileConsent = localStorage.getItem("user_consent_triggered") === "true";
						if (shouldTriggerMobileConsent && this.serverData && this.lastLocale) {
							await showMobileConsent(appConfig, this.serverData, this.lastLocale);
						}
					};
					// For when app is actually "killed"
					await self.setupPushNotifications();
					await setConsents();

					// For when app is not actually "killed" but only put in the background
					NativeApp.addListener("resume", async () => {
						await self.setupPushNotifications();
						await setConsents();
					});
				}

				await addCapacitorPushListener("pushNotificationActionPerformed", (notificationObj) => onPushNotificationActionPerformedCallback(this.$router, this.$store, notificationObj));
				await addCapacitorPushListener("pushNotificationReceived", (notification) => onPushNotificationReceivedCallback(this, notification));
				await addCapacitorPushListener("registration", async (token) => {
					if (appConfig.isBM100()) {
						self.$store.commit(mutationTypes.FCM_TOKEN, token.value);
					}
					if (!self.shouldHandlePushRegistration) return;
					self.$store.commit(mutationTypes.SET_SHOULD_HANDLE_PUSH_REGISTRATION, false);
					self.$store.commit(mutationTypes.PUSH_NOTIFICATIONS_GRANTED, true);
				});

				if (this.platform === "android" && deviceInfo.androidSDKVersion < 33) {
					// On Android with API level under 33 it doesn't prompt for permission because you can always receive push notifications.
					self.$store.commit(mutationTypes.SET_SHOULD_HANDLE_PUSH_REGISTRATION, true);
					await registerCapacitorPushNotifications();
					// eslint-disable-next-line no-console
					console.log("[INFO] Registered for push notifications.");
				} else if ((this.platform === "ios" || deviceInfo.androidSDKVersion >= 33) && (appConfig.isBM6())) {
					let permStatus = await checkCapacitorPushPermissions();

					if (permStatus === "prompt") {
						permStatus = await requestCapacitorPushPermissions();
					}

					if (permStatus !== "granted") {
						throw new Error("User denied push notificaitons!");
					}

					self.$store.commit(mutationTypes.SET_SHOULD_HANDLE_PUSH_REGISTRATION, true);
					await registerCapacitorPushNotifications();
				}

				subscribeToUniversalLinks(self.$router);
			}

			if (appConfig.isBM100()) {
				if (this.channelAliasKiosk) {
					await this.loadShops();

					window.onmessage = e => {
						if (!e.data || !e.data.type || e.data.type !== "KIOSK_UPDATE_REQUEST") {
							return;
						}

						this.$store.dispatch(mutationTypesBM100.KIOSK_UPDATE_REQUEST, true);
					};
				}
			}
		},
		computed: {
			...mapGetters([
				"featureToggles", "globalError", "globalErrorMessage", "redirectToLogin",
				"customGlobalErrorMessage", "tenantSettings",
				"selectionExpiredMessage", "globalSelectedShop", "isNavBarOpen",
				"globalInfoDialog", "serverData", "lastLocale", "personData", "shouldHandlePushRegistration"
			]),
			productSelections() {
				return this.$store.getters.selections;
			},
			channelAliasKiosk() {
				return appConfig.channelAlias() === "kiosk";
			},
			channelAliasDesktop() {
				return appConfig.channelAlias() === "desktopBrowser";
			},
			isAdminRoute() {
				return this.$route.name !== null && routerMapper.isAdminRoute(this.$route.name);
			},
			isFrontRoute() {
				return this.$route.name !== null && !this.isAdminRoute;
			},
			routeAppClass() {
				switch (this.$route.name) {
				case "Home":
					return "home";
				default:
					return "";
				}
			},
			isPopupEnv() {
				const nonPopupEnvs = ["p", "o", "q"];
				return !nonPopupEnvs.includes(appConfig.envPrefix());
			},
			screenId() {
				return this.isAdminRoute ? `S-${this.$route.name}` : routerMapper.getScreenId(this.$route.name);
			},
			gtCssClass() {
				// all tenants should use globalTemplateName based on their business model rather than id

				// except old SG tenants
				if (tenantConfig.isSGTenant) {
					return `tid${tenantConfig.tenantId}-style`;
				}

				if (appConfig.globalTemplateReplaceCss) {
					const postfixName = getGlobalTemplateReplaceCssName(appConfig.tenantId, appConfig.globalTemplateReplaceCss);
					if (postfixName) {
						return `style-gt3-${postfixName}`;
					}
				}

				// the rest...
				if(appConfig.getBusinessModelId() === appConfig.businessModelsEnum.bm100.id) {
					if(appConfig.globalTemplateName !== undefined && appConfig.globalTemplateName === "gt2"){
						return `style-gt2`;
					} else if (appConfig.globalTemplateName !== undefined && appConfig.globalTemplateName === "gt3") {
						return `style-gt3-refactored`;
					}
				}
			},
			variantCssClass() {
				const self = this;

				if (appConfig.styleVariant) {
					return `${self.gtCssClass}-${appConfig.styleVariant}`;
				}

				return undefined;
			},
			showNotAvailable() {
				const self = this;
				const isTenantUnavailable = self.tenantSettings && self.tenantSettings.isTenantUnavailable;

				if (appConfig.isBM100()) {
					return isTenantUnavailable;
				}

				return this.platform === "" ? isTenantUnavailable : false;
			},
			showNotAvailableAndroid()	{
				const self = this;
				if (this.platform === "android"){
					return self.tenantSettings && self.tenantSettings.isTenantUnavailableAndroid;
				}
			},
			showNotAvailableIos() {
				const self = this;
				if (this.platform === "ios"){
					return self.tenantSettings && self.tenantSettings.isTenantUnavailableIos;
				}
			},
			showNotAvailableDesktopBrowser() {
				const self = this;
				if (this.channelAliasDesktop) {
					return self.tenantSettings && self.tenantSettings.isTenantUnavailableDesktopBrowser;
				}
			},
			showNotAvailableKiosk() {
				const self = this;
				if (this.channelAliasKiosk) {
					return self.tenantSettings && self.tenantSettings.isTenantUnavailableKiosk;
				}
			},
			showNotAvailableMobileBrowser() {
				const self = this;
				if(appConfig.channelAlias() === "mobileBrowser") {
					return self.tenantSettings && self.tenantSettings.isTenantUnavailableMobileBrowser;
				}
			},
			platform() {
				if (appConfig.mobile.isMobileApp()) {
					const mobileApi = appConfig.mobile.mobileApi();
					return mobileApi.platformId;
				}
				return "";
			},
			isBrowserSupportDiscontinued() {
				const userAgent = window.navigator.userAgent;
				// For IE 10 or older
				const msie10 = userAgent.indexOf("MSIE") > 0;
				const msie11 = userAgent.indexOf("Trident") > 0;

				return (msie10 || msie11);
			},
			tenantName() {
				return tenantConfig.tenantName;
			},
			templateType() {
				if (tenantConfig.isSGTenant) {
					return `SiteNotAvailableTid${appConfig.tenantId}`;
				} else {
					const bmId = appConfig.getBusinessModelId().toUpperCase();
					return `SiteNotAvailable${bmId}`;
				}
			},
			betaMode() {
				return appConfig.isBetaMode();
			},
			isBM100() {
				return appConfig.getBusinessModelId() === appConfig.businessModelsEnum.bm100.id;
			},
			isNextVersion() {
				return getVersion() === "next";
			},
			voucherReservationTime() {
				return this.$store.getters.voucherReservationTime;
			}
		},
		async mounted() {
			this.discountExpirationPopupTimeInSeconds = this.tenantSettings && this.tenantSettings.timers ? this.tenantSettings.timers.discountExpirationPopupTimeInSeconds : 600;
			HelloRetail.trackingUserForGuests(this);
			const self = this;
			self.$store.watch(() => self.$store.getters.redirectToLogin, self.redirectToLoginAction);
			self.redirectToLoginAction(self.redirectToLogin);
			this.$nextTick(() => {
				self.prepareApmTransactionNames();
			});
		},
		beforeDestroy(){
			this.closeConnectionToSse();
			if (this.sseClientInterval) {
				clearTimeout(this.sseClientInterval);
			}
			Object.values(this.timerIds).forEach(id => clearTimeout(id));
			this.timerIds = {};
			// Clean up voucher timeouts
			Object.values(this.voucherTimeouts).forEach(id => clearTimeout(id));
			this.voucherTimeouts = {};
		},
		methods: {
			handleNewMessageApiCall() {
				this.$refs.topMenuAdmin.getOrdersWithNewMessages();
			},
			async deleteUser(){
				return this.$store.dispatch(mutationTypes.PERSON_DELETE_ACCOUNT, { eventName: `${this.$route.name}` });
			},
			getIconUrl(category){
				const self = this;
				return category.isSelected ? `${self.staticPath}${category.iconUrl}` : `${self.staticPath}${category.inactiveIconUrl}`;
			},
			replaceDanishChars(str){
				const chars = {"æ":"ae","ø":"oe","å":"aa", "Æ": "Ae", "Ø": "Oe", "Å": "Aa"};
				return str.replace(/[æøåÆØÅ]/g, m => chars[m]);
			},
			removeNonAsciiChars(str){
				// eslint-disable-next-line no-control-regex
				return str.replace(/[^\x00-\x7F]/g, "");
			},
			prepareApmTransactionNames(){
				const self = this;
				if(ApmHelper.isEnabled()) {
					window.addEventListener("click", function (event) {
						if (event && event.target) {
							const tx = self.$apm.getCurrentTransaction();

							if (!tx || (tx && tx.ended)) return;

							const splittedURI = event.target.baseURI.split("/");
							if(splittedURI.length > 4 && splittedURI[4] !== "") {
								const isBM100Category = appConfig.isBM100() && splittedURI[3] === "category";
								if (!isBM100Category) {
									const labelName = `${splittedURI[3]}Id`;
									const labelValue = splittedURI[4];
									ApmHelper.addLabel(labelName, labelValue);
								}
							} else if(splittedURI.length > 5 && splittedURI[5] !== ""){
								const customValue = splittedURI.slice(5, splittedURI.length).join("_");
								ApmHelper.addCustomContext("additionalURIData", customValue);
							}
							//const joinedPathParts = splittedURI.slice(3, splittedURI.length).join("_");
							const name = event.target.name ?
								event.target.name :
								(event.target.id ? event.target.id : undefined);
							const innerText = event.target.innerText ? event.target.innerText.replace(/\s+/g, "") : "";
							let nameOrInnerText = name ? name : (innerText ? innerText : undefined);

							if (event.path) {
								let value = undefined;
								let maxDeep = 10;

								for (const el of event.path) {
									if (el.attributes) {
										const name = el.attributes.getNamedItem("data-apm-span");
										if (name) {
											value = name.value;
											break;
										}

										if (!maxDeep--) break;
									}
								}

								nameOrInnerText = value || nameOrInnerText;
							}

							if (nameOrInnerText) {
								const limitedNameOrInnerText = nameOrInnerText.length > 30 ? nameOrInnerText.substring(0, 30) : nameOrInnerText;
								tx.name= self.removeNonAsciiChars(self.replaceDanishChars(`${splittedURI[3]}/${limitedNameOrInnerText}`));
							}
						}
					});
				}
			},
			closeErrorMessage() { // TODO this should be moved
				if (this.globalError && (this.globalError.errorObject || {}).errorCode === "ProductIsInactive") {
					this.$store.dispatch(mutationTypes.CLEAR_GLOBAL_ERRORS);
					this.$router.push({path: "/checkout"});
				} else if(this.globalError) { // we should not touch state here if globalError is not set
					this.$store.dispatch(mutationTypes.CLEAR_GLOBAL_ERRORS);
				}
				if (this.$store.getters.redirectPath) {
					this.$router.push(this.$store.getters.redirectPath);
					this.$store.commit(mutationTypes.SET_REDIRECT_PATH, null);
				}
			},
			redirectToLoginAction(doRedirect) {
				if (doRedirect) {
					this.$store.dispatch(mutationTypes.CLEAR_REDIRECT_TO_LOGIN);
					if(this.isAdminRoute){
						this.$router.push("/admin/login");
					}
				}
			},
			redirectToShopOnCondition(condition) {
				if (condition) {
					this.$router.push({path: "/shop-pre-selection"});
				}
			},
			siteNotAvailableRedirect() {
				window.open(tenantConfig.siteNotAvailableRedirectUrl);
			},
			connectKioskToSse() {
				const self = this;
				const {refreshKioskUsingSse, enableKioskQrCode, enableScanningQrCodeInApplicationNewDesign} = self.featureToggles;
				const sseRefreshFlag = self.channelAliasKiosk && refreshKioskUsingSse;
				const sseKioskLoginWithMobileQrCodeScan = self.channelAliasKiosk && enableKioskQrCode;
				const sseKioskLoginWithMobileAppNumber = self.channelAliasKiosk && enableScanningQrCodeInApplicationNewDesign;
				const shouldInitSse = sseRefreshFlag || sseKioskLoginWithMobileQrCodeScan;
				if (!shouldInitSse) {
					return;
				}
				if (self.$route.name !== "Home") {
					self.closeConnectionToSse();
					return;
				}
				if (!self.sseClient) {
					self.sseInit();
				}
				// register listeners
				if (sseRefreshFlag) {
					self.sseClient.addEventListener("sse-refresh-application", self.refreshFunction);
				}
				if (sseKioskLoginWithMobileQrCodeScan) {
					self.sseClient.addEventListener("sse-kiosk-login-with-mobile-app-qr-code-scan", self.qrCodeScanLoginFunction);
				}
				if (sseKioskLoginWithMobileAppNumber) {
					self.sseClient.addEventListener("sse-kiosk-login-with-mobile-app-number-id", self.qrCodeScanLoginFunction);
				}
			},
			sseInit() {
				const self = this;
				const sseApiUrl = appConfig.getBaseApiNestUrl() + "/sse";
				// checking if browser supports native event source. If it doesn't we will use the polyfill
				if (window.EventSource) {
					self.sseClient = new window.EventSource(sseApiUrl);
				} else {
					self.sseClient = new EventSource(sseApiUrl);
				}

				// if for any reason we receive an error on the sse connection
				// if the error is from the server side, we will close the connection and reattempt after every 10 seconds until we get a successful connection
				// if the error is on the frontend side, we will not destroy the connection.
				self.sseClient.onerror = function (error) {
					// eslint-disable-next-line
					console.log("sse error received: " + JSON.stringify(error));

					if (error.status && (error.status === 500 || error.status === 502 || error.status === 503 || error.status === 504)) {
						self.closeConnectionToSse(true);
					}
				};
			},
			closeConnectionToSse(makeReconnectionAttempt) {
				const self = this;
				if (self.sseClient) {
					// Unsubscribe when navigating away, so it won't try to refresh during a checkout.
					self.sseClient.removeEventListener("sse-refresh-application", self.refreshFunction);
					self.sseClient.removeEventListener("sse-kiosk-login-with-mobile-app-qr-code-scan", self.qrCodeScanLoginFunction);
					// Need to close EventSource because limit is 6 connections per domain per browser.
					// This means you can run out of connections very quickly, so there can't be many open FoodShop tabs.
					self.sseClient.close();
					self.sseClient = null;

					// if makeReconnectionAttempt is set to true, this means that the error was from server and
					// we have to reconnect to sse after 10 seconds.
					if (makeReconnectionAttempt) {
						this.sseClientInterval = setTimeout(function () {
							self.connectKioskToSse();
						}, 10000);
					}
				}
			},
			qrCodeScanLoginFunction(event) {
				function loginViaSSE(eventData) {
					window.parent.postMessage({
						type: "KIOSK_LOGIN_WITH_MOBILE_APP_QR_CODE_SCAN",
						payload: eventData
					}, "*");
				}
				// eslint-disable-next-line
				console.log("[qrCodeScanLoginFunction] message received from sse", event);
				const eventData = JSON.parse(event.data);
				const numberCode = eventData.numberCode ? +eventData.numberCode : null;
				/**
				 * sseRefreshApplicationUUID
				 *
				 * this is some kind of protection not to perform login on entry to kiosk landing page,
				 * because qrCodeScanLoginFunction is called on every kiosk landing page entry (because we are doing closeConnectionToSse every
				 * time we leave the route, and then on every entry to this route, inside the connectKioskToSse,
				 * we call backend /sse and get the existing data)
				 */
				const sseRefreshApplicationUUID = localStorage.getItem("sseRefreshApplicationUUID") || "";
				if (sseRefreshApplicationUUID === eventData.uuid) {
					// eslint-disable-next-line
					console.log("[qrCodeScanLoginFunction]", "sseRefreshApplicationUUID is the same as eventData.uuid, do not authenticate again!");
					return;
				}
				if (eventData.tenantId !== tenantConfig.tenantId) {
					// eslint-disable-next-line
					console.log("[qrCodeScanLoginFunction]", "did not work because tenantId did not match");
					return;
				}
				localStorage.setItem("sseRefreshApplicationUUID", eventData.uuid);
				if(numberCode && numberCode === this.$store.getters.uniqueSessionId) {
					loginViaSSE(eventData);
					return;
				}
				// if user tried number login, it doesn't make sense to try conditions bellow
				if(numberCode) {
					return;
				}
				const shopNumber = new URLSearchParams(window.location.search).get("shopNumber") || this.globalSelectedShop.shopNumber;
				if (!shopNumber || shopNumber !== eventData.shopNumber) {
					// eslint-disable-next-line
					console.log("[qrCodeScanLoginFunction_shopNumber]", "do not authenticate user on this kiosk device");
					return;
				}
				const kioskDeviceId = window.kioskHost.shopDeviceIdentifier;
				if (!kioskDeviceId || kioskDeviceId !== eventData.shopDeviceId) {
					// eslint-disable-next-line
					console.log("[qrCodeScanLoginFunction_kioskDeviceId]", "do not authenticate user on this kiosk device");
					return;
				}
				loginViaSSE(eventData);
			},
			refreshFunction(event) {
				const self = this;
				// eslint-disable-next-line
				console.log("message received from sse", event);

				const eventData = JSON.parse(event.data);
				if (eventData.tenantId !== tenantConfig.tenantId) {
					// eslint-disable-next-line
					console.log("refreshFunction", "refresh did not work because tenantId did not match");
					return;
				}

				// checking whether the refresh function emitted from the same shop as the one we are currently on.
				// if shopNumber is not provided, it means that the refresh will work for all shops.
				// shopNumber is only present if the channel is kiosk so we will check for shopNumber only on kiosk
				if (self.channelAliasKiosk && eventData.shopNumber && (appConfig.preselectedShopNumber() !== eventData.shopNumber)) {
					// eslint-disable-next-line
					console.log("refreshFunction", "refresh did not work because shopNumber did not match");
					return;
				}

				// checking whether the refresh function emitted for the same channel as the one we are currently on.
				// if no alias is provided, it means that the refresh will work for all channels.
				if (eventData.channelAlias && (appConfig.channelAlias() !== eventData.channelAlias)) {
					// eslint-disable-next-line
					console.log("refreshFunction", "refresh did not work because channel did not match");
					return;
				}

				const sseRefreshApplicationUUID = localStorage.getItem("sseRefreshApplicationUUID") || "";
				if (sseRefreshApplicationUUID !== eventData.uuid) {
					localStorage.setItem("sseRefreshApplicationUUID", eventData.uuid);
					localStorage.setItem("sseRefreshApplicationShopForceRefreshFlag", true);

					// if we are on the mobile app and we receive an sse event "sse-refresh-application"
					// simply alert a message as a Proof of concept to verify that sse is working on the mobile app.
					if (appConfig.mobile.isMobileApp()) {
						// this alert will only work on non-production environment
						// for production environment, this code should not work
						if (appConfig.isNonProdZone()) {
							alert("sse refresh event caught on mobile app");
						}
						return;
					}

					location.reload();
				}
			},
			redirectToLoginRoute() {
				this.$store.commit(mutationTypes.SET_GLOBAL_INFO_DIALOG, null);
				this.$store.commit(mutationTypes.REMEMBER_LOGIN_HISTORY, false);
				this.$router.push("/check-email");
			},
			closeInfoDialog() {
				this.$store.commit(mutationTypes.SET_GLOBAL_INFO_DIALOG, null);
				if(this.$route.name === routerMapper.routeNames.DeliveryMethod && this.$store.getters.getLoginHistory) {
					this.$store.commit(mutationTypes.REMEMBER_LOGIN_HISTORY, false);
				}
			},
			async loadShops() {
				const sseRefreshApplicationUUID = localStorage.getItem("sseRefreshApplicationUUID") || false;
				if (sseRefreshApplicationUUID) {
					await this.$store.commit(mutationTypes.UNSET_GLOBAL_SELECTED_SHOP);
				}
				Promise.all([
					this.$store.dispatch(mutationTypes.FETCH_AND_CACHE_SHOPS, {
						onlyActive: false,
						showSecretRestaurants: true
					})
				]).then(async ([shops]) => {
					if (!appConfig.preselectedShopNumber()) {
						this.redirectToShopOnCondition(true);
						return;
					}
					const preselectedShopNumber = appConfig.preselectedShopNumber() + "";
					const shopNumberPath = tenantConfig.shopNumberPath || "shopNumber";
					const shop = shops.find(s => {
						const shopNumber = _.get(s, shopNumberPath);
						return (shopNumber + "") === preselectedShopNumber;
					});
					if (shop) {
						const globalSelectedShopRefreshToken = localStorage.getItem("globalSelectedShopRefreshToken");
						if (globalSelectedShopRefreshToken) {
							this.$store.commit(
								mutationTypes.SET_GLOBAL_SELECTED_SHOP_REFRESH_TOKEN,
								globalSelectedShopRefreshToken
							);
						}

						localStorage.removeItem("globalSelectedShopRefreshToken");
						localStorage.removeItem("globalSelectedShopId");

						await this.$store.dispatch("setGlobalSelectedShop", shop);
					} else {
						const globalSelectedShop = this.$store.getters.globalSelectedShop;
						if (globalSelectedShop) {
							localStorage.setItem("globalSelectedShopId", globalSelectedShop.id);
						}
						this.$store.commit(mutationTypes.UNSET_GLOBAL_SELECTED_SHOP);
					}
				});
			},
			async hideSplashScreen() {
				await SplashScreen.hide();
			},
			removeVersion() {
				sessionStorage.removeItem("version");
				window.location = window.location.pathname;
			},
			cleanUpVoucherFromOrder(voucherId) {
				this.$store.commit(mutationTypes.REMOVE_VOUCHER_FROM_ORDER, voucherId);
				this.$store.commit(mutationTypes.SET_VOUCHER_VIRTUAL_ORDER_ID);
				const newOrderTags = (this.$store.getters.cartOrderTags || []).filter(
					(tag) => {
						return !tag.includes(`${voucherId}, `);
					}
				);
				this.$store.commit(mutationTypes.SET_CART_ORDER_TAGS, newOrderTags);
				if(this.voucherTimeouts[voucherId]) {
					delete this.voucherTimeouts[voucherId];
				}
				this.$store.dispatch(RECALCULATE_SUBSCRIPTION_SET_CART_ORDER_TAGS);
				if(this.$store.getters.cartProducts.length) {
					this.$store.commit(
						mutationTypes.SET_GLOBAL_INFO_DIALOG,
						"utilityComponents.voucherInput.reservationExpired"
					);
				}
			},
			handleVoucherReservationTimeout(voucherId, data) {
				// Clear existing timeout for this voucher if any
				if (this.voucherTimeouts[voucherId]) {
					clearTimeout(this.voucherTimeouts[voucherId]);
				}

				if(!data || typeof data !== "object" || !data.time || !data.timeZone) {
					// Invalid data, remove voucher immediately
					this.cleanUpVoucherFromOrder(voucherId);
					return;
				}

				const expirationTime = DateTime.fromFormat(data.time, "yyyy-MM-dd HH:mm:ss", { zone: data.timeZone });
				const now = DateTime.now();
				const msUntilExpiration = expirationTime.diff(now).milliseconds;

				if (msUntilExpiration > 0) {
					this.voucherTimeouts[voucherId] = setTimeout(() => {
						this.cleanUpVoucherFromOrder(voucherId);
					}, msUntilExpiration);
				} else {
					// Already expired, we can remove it immediately
					this.cleanUpVoucherFromOrder(voucherId);
				}
			},
			async setupPushNotifications() {
				const self = this;
				if (self.personData && appConfig.isBM100() && appConfig.mobile.isMobileApp()) {
					const capacitorPermStatus = await checkCapacitorPushPermissions();
					const sfmcPermStatus = await checkSFMCPushSystemPermission();
					const granted = capacitorPermStatus === "granted" || sfmcPermStatus === "granted";
					if (!granted) return;

					const currentContactKey = await getSFMCContactKey();

					if (!currentContactKey || currentContactKey !== self.personData.sfmcContactKey) {
						await setSFMCContactKey(self.personData.sfmcContactKey);
					}
				}
			}
		},
		watch: {
			isFrontRoute() {
				const self = this;
				if (self.isFrontRoute === true) {
					// FB pixel
					appConfig.fbPixel("track", "PageView");
				}
			},
			productSelections: {
				deep: true,
				immediate: true,
				handler(selections) {
					const blockedRoutes = ["pendingorderscreen", "pendingorder", "payment", "paymentdesktop", "pendingorderdesktop", ""];

					const routeName = (this.$route.name || "").toLowerCase();

					if (blockedRoutes.includes(routeName)) {
						return;
					}

					selections.forEach(sel => {
						const allDiscountedItems = collectSelectionsWithDiscount(sel);


						allDiscountedItems.forEach(({ id, discountExpiresAt }) => {
							if (["home", ""].includes(routeName) && this.channelAliasKiosk) {
								Object.keys(this.timerIds).forEach(id => {
									clearTimeout(this.timerIds[id]);
									delete this.timerIds[id];
								});

								this.shownDialogs = {};

								return;
							}
							if (this.shownDialogs[id]) return;

							if (this.timerIds[id]) clearTimeout(this.timerIds[id]);
							const expiry = DateTime.fromISO(discountExpiresAt, { zone: "utc" });

							const beforeExpiry = expiry.minus({ seconds: this.discountExpirationPopupTimeInSeconds });

							const delay = beforeExpiry.toMillis() - DateTime.now().toMillis();

							const showDialog = () => {
								this.$store.commit(
									mutationTypes.SET_GLOBAL_INFO_DIALOG,
									"knownErrors.timeBasedPriceRuleExpired"
								);
								this.shownDialogs[id] = true;
								delete this.timerIds[id];
							};

							if (delay > 0) {
								this.timerIds[id] = setTimeout(showDialog, delay);
							} else {
								showDialog();
							}
						});
					});
				}
			},
			voucherReservationTime(newValue, oldValue) {
				// Clean up old timeouts that are no longer in the new value
				if (oldValue) {
					for (const voucherId of Object.keys(oldValue)) {
						if ((!newValue || !newValue[voucherId]) && this.voucherTimeouts[voucherId]) {
							clearTimeout(this.voucherTimeouts[voucherId]);
							delete this.voucherTimeouts[voucherId];
						}
					}
				}

				if (newValue) {
					for (const voucherId of Object.keys(newValue)) {
						this.handleVoucherReservationTimeout(voucherId, newValue[voucherId]);
					}
				}
			},
			"$store.getters.featureToggles.enableKioskQrCode"(newValue){
				if (newValue && this.$route.name === "Home") {
					this.connectKioskToSse();
				}
			},
			"$store.getters.featureToggles.enableKioskQrCodeNewDesign"(newValue){
				if (newValue && this.$route.name === "Home") {
					this.connectKioskToSse();
				}
			},
			$route: {
				handler: function () {
					this.connectKioskToSse();
					this.$store.dispatch("closeNavBar");
					if(this.$store.getters.featureToggles.enableShowPageTitle) {
						setPageTitle(this.$route, this.$store.getters.productCatalog);
					}
				},

				immediate: true
			},
			isNavBarOpen() {
				if (this.$refs.topMenuAdmin) {
					this.topMenuAdminHeight = this.$refs.topMenuAdmin.$refs.adminToolBar.$el.clientHeight;
				}
			},
			personData(newValue) {
				const self = this;
				if (newValue) {
					self.setupPushNotifications();
				}
			}
		}
	};
</script>

<style lang="scss">
	.tid1-style {
		@import "./scss/tenantSpecific/globalcss-tid1.scss";
	}

	.tid1-style-gt3 {
		@import "scss/tenantSpecific/globalcss-tid1-gt3";
	}

	.tid2-style {
		@import "./scss/tenantSpecific/globalcss-tid2.scss";
	}

	.tid3-style {
		@import "./scss/tenantSpecific/globalcss-tid3.scss";
	}

	.tid5-style {
		@import "./scss/tenantSpecific/globalcss-tid5.scss";
	}

	.tid6-style {
		@import "./scss/tenantSpecific/globalcss-tid6.scss";
		flex: 1;
	}

	.style-gt2 {
		@import "scss/globalTemplateSpecific/globalcss-gt2";
		flex: 1;
	}

	.style-gt3-refactored {
		@import "scss/globalTemplateSpecific/globalcss-gt3-refactored";
	}

	.style-gt3-a {
		@import "scss/globalTemplateSpecific/globalcss-gt3a";
	}

	.style-gt3-400  {
		@import "scss/tenantSpecific/tid400/globalcss-tid400-gt3";
	}

	.style-gt3-400-a  {
		@import "scss/tenantSpecific/tid400/globalcss-tid400-gt3a";
	}

	.style-gt3-400m {
		@import "scss/tenantSpecific/tid400/globalcss-tid400m-gt2";
		flex: 1;
	}

	.style-gt3-500  {
		@import "scss/tenantSpecific/tid500/globalcss-tid500-gt3";
	}

	.style-gt3-500-a  {
		@import "scss/tenantSpecific/tid500/globalcss-tid500-gt3a";
	}

	.style-gt3-500m {
		@import "scss/tenantSpecific/tid500/globalcss-tid500m-gt2";
		flex: 1;
	}

	@import "./scss/base.scss";
</style>

<style scoped>
	.sunset-logo-disable-page, .sunset-ie, .sunset-brocken{
		display: none;
	}

	.global-error {
		position: fixed;
		display: none;
		bottom: 0;
		right: 0;
		left: 0;
		background-color: #cd6a76;
		color: white;
		padding: 1.5em;
		cursor: pointer;
		text-align: center;
		font-weight: 900;
		z-index: 10001;
	}

	.global-error.has-error {
		display: block;
	}

	.global-error .close {
		cursor: pointer;
		padding-right: 2em;
		float: right;
	}

	div#app {
		width: 100%;
		margin: auto;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.version {
		position: absolute;
		left: 50%;
		color: white;
		border: 1px solid white;
		border-radius: 5px;
		z-index: 1000;
		transform: translate(-50%, 10px);
		background-color: #0d0109 !important;
	}

</style>

<style lang="scss">
	/* ADMIN CSS STYLE ONLY */
	.admin {
		div#app {
			background-color: #c8c8c8 !important;
		}
		.admin-btn-small {
			font-size: 13px;
			height: auto;
			line-height: 24px;
			//margin-bottom: 5px !important;

			.v-btn__content {
				flex: 1 1 auto !important;
				white-space: normal;
			}

		}
		.admin-btn-orange {
			background-color: #fff !important;
			opacity: 1 !important;
			text-align: center;
			.v-btn__content {
				color: #f6a623 !important;
				font-size: 14px;
				font-weight: bold;
				opacity: 1 !important;
			}
			&.v-btn-toggle--selected {
				color: #f6a623 !important;
			}
		}
		.admin-btn-gray {
			.v-btn__content {
				color: #4a4a4a !important;
			}
		}
	}
	.sm-brocken, .bil-brocken, .fo-brocken{
		font-size: 40px;
		text-align: center;
		font-weight: bold;
		width: 14em;
		margin: auto;
		line-height: normal;
	}
	.sm-brocken span, .bil-brocken span, .fo-brocken span {
		display: block;
	}
	.bil-brocken-sub, .sm-brocken-sub, .fo-brocken-sub {
		font-size: 24px;
		text-align: center;
		padding-top: 1.5em;
		padding-left: 1em;
		padding-right: 1em;
		width: 25em;
    	margin: auto;
	}
	.bil-brocken-sub span, .sm-brocken-sub span, .fo-brocken-sub span {
		display: block;
	}
	.salling-btn, .bilka-btn, .fotex-btn {
		height: 60px;
		width: 300px;
		border-radius: 10px;
		font-size: 24px;
		text-transform: none;
	}
	.center-button-align {
		text-align: center;
		padding-top: 1.5em;
	}
	.bil-brocken-sub-bold, .sm-brocken-sub-bold, .fo-brocken-sub-bold {
		width: 32em;
		text-align: center;
		padding-top: 1em;
		margin: auto;
		font-family: 'Open Sans', sans-serif !important;
		font-weight: bold;
		font-size: 25px;
	}
	.bilka-ie,.smag-ie,.fotex-ie {
		width: 30em;
		text-align: center;
		padding-top: 1em;
		margin: auto;
		font-family: 'Open Sans', sans-serif !important;
		font-size: 21px;
	}
	.available-browsers {
		text-align: center;
		padding-top: 1em;
		font-family: 'Open Sans', sans-serif !important;
		font-weight: bold;
		font-size: 22px;
	}
	.all-tenants-ie {
		font-family: 'Open Sans', sans-serif !important;
	}
	.image-browsers {
		display: block;
		margin: auto;
		margin-top: 20px;
	}
@media (max-width: 750px){
	.sm-brocken, .bil-brocken, .fo-brocken {
		width: 11em;
	}
	.bil-brocken-sub, .sm-brocken-sub, .fo-brocken-sub {
		width: 17em;
	}
}
@media (max-width: 450px){
	.sm-brocken, .bil-brocken, .fo-brocken {
		width: 100%;
	}
	.bil-brocken-sub, .sm-brocken-sub, .fo-brocken-sub {
		width: 100%;
	}
}

</style>
